if (!customElements.get('wls-main-article')) {
  class WLSMainArticle extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        articleRTE: 'js-main-article-rte',
        asideTrackList: 'js-main-article-aside-track-list',
        active: 'active',
      };

      this.headings = [];
      this.observer = null;
    }

    get elements() {
      return {
        articleRTE: this.querySelector(`.${this.classes.articleRTE}`),
        asideTrackList: this.querySelector(`.${this.classes.asideTrackList}`),
      };
    }

    connectedCallback() {
      this.initTableOfContents();
      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    initTableOfContents() {
      const { articleRTE, asideTrackList } = this.elements;

      if (!articleRTE || !asideTrackList) return;

      // Find all headings in the article content
      this.headings = Array.from(articleRTE.querySelectorAll('h1, h2, h3, h4, h5, h6'));

      if (this.headings.length === 0) return;

      // Clear existing content
      asideTrackList.innerHTML = '';

      // Generate table of contents
      this.headings.forEach((heading, index) => {
        // Create unique ID for heading
        const headingId = this.generateHeadingId(heading.textContent, index);
        heading.id = headingId;

        // Create list item with anchor link
        const listItem = document.createElement('li');

        const anchor = document.createElement('a');
        anchor.href = `#${headingId}`;
        anchor.textContent = heading.textContent.trim();
        anchor.addEventListener('click', this.handleAnchorClick.bind(this));

        listItem.appendChild(anchor);
        asideTrackList.appendChild(listItem);
      });

      // Initialize intersection observer for active link updates
      this.initIntersectionObserver();
    }

    generateHeadingId(text, index) {
      // Create a URL-friendly ID from heading text
      const baseId = text
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Replace multiple hyphens with single
        .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens

      return baseId || `heading-${index}`;
    }

    handleAnchorClick(event) {
      event.preventDefault();
      const targetId = event.target.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const headerOffset = 100; // Offset from top of viewport in pixels
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }

    initIntersectionObserver() {
      if (!this.headings.length) return;

      const options = {
        root: null,
        rootMargin: '-20% 0px -70% 0px', // Trigger when heading is in top 30% of viewport
        threshold: 0,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.updateActiveLink(entry.target.id);
          }
        });
      }, options);

      // Observe all headings
      this.headings.forEach((heading) => {
        this.observer.observe(heading);
      });
    }

    updateActiveLink(activeHeadingId) {
      const { asideTrackList } = this.elements;
      if (!asideTrackList) return;

      // Remove active class from all links
      const allLinks = asideTrackList.querySelectorAll('a');
      allLinks.forEach((link) => {
        link.parentElement.classList.remove(this.classes.active);
      });

      // Add active class to current link
      const activeLink = asideTrackList.querySelector(`a[href="#${activeHeadingId}"]`);
      if (activeLink) {
        activeLink.parentElement.classList.add(this.classes.active);
      }
    }

    bindEvents() {
      // Additional event bindings can be added here if needed
    }
  }
  customElements.define('wls-main-article', WLSMainArticle);
}
